// UK date/time formatting helpers (Europe/London)
const TZ = "Europe/London";

export function formatDate(iso, opts = {}) {
  if (!iso) return "";
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  return d.toLocaleDateString("en-GB", { weekday: opts.weekday || "long", day: "numeric", month: "long", year: opts.year ? "numeric" : undefined, timeZone: TZ });
}

export function formatDateShort(iso) {
  if (!iso) return "";
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: TZ });
}

export function formatDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: TZ });
}

export function formatTime(t) {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const suffix = h >= 12 ? "pm" : "am";
  const hr = h % 12 === 0 ? 12 : h % 12;
  return m === 0 ? `${hr}${suffix}` : `${hr}:${String(m).padStart(2, "0")}${suffix}`;
}

export function formatPrice(p) {
  if (p == null) return "";
  return p === 0 ? "Free" : `£${Number(p).toFixed(2).replace(/\.00$/, "")}`;
}

export function todayISO() {
  return new Date().toLocaleDateString("en-CA", { timeZone: TZ }); // YYYY-MM-DD
}

export const LEVELS = ["Absolute Beginner", "Beginner", "Improver", "Intermediate"];
export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const STATUS_LABELS = { learning: "Learning", know_it: "Know It", favourite: "Favourite" };
